import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';

const CardHeading = ({ title, subtitle }) => (
  <Heading className="text-center text-neutral-high-100" size="size3">
    {title} /{' '}
    <Heading as="span" className="text-neutral-high-100" size="size5">
      {subtitle}
    </Heading>
  </Heading>
);

CardHeading.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default CardHeading;
